(function () {
    'use strict';

    angular
        .module('franchisee-portal.interceptors')
        .factory('cacheFileFactory', CacheFileFactory)

    /** @ngInject */
    function CacheFileFactory() {
        return {
            request: request
        }

        function request(config) {
            if (config.url.includes('.html') || config.url.includes('.json')) {
                Object.assign(config.headers, {
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Vary': 'User-Agent'
                });
            }

            return config;
        }
    }
}());